import React from "react"
import {
	Grid,
	Typography,
	Card,
	Box
} from "@material-ui/core"
import {
	Adjust as AdjustIcon
} from "@material-ui/icons"

import { MeetingAnalysis } from "@/services/MeetingAnalyzerService"

import useMeetingAnalyzerStyles from "@/pages/Admin/MeetingAnalyzer/Detail/styles"
import useStyles from "@/pages/Admin/MeetingAnalyzer/Detail/NextStepsCard/styles"

type NextStepsCardProps = {
	analysis: MeetingAnalysis
}

const NextStepsCard: React.FC<NextStepsCardProps> = (props) => {
	const { analysis } = props

	const meetingAnalyzerClasses = useMeetingAnalyzerStyles()
	const classes = useStyles()

	if (!analysis.output) {
		return null
	}

	const nextSteps = analysis.output.nextSteps

	return (
		<Card className={meetingAnalyzerClasses.card}>
			<Grid container direction="column" spacing={2}>
				<Grid item>
					<Typography className={meetingAnalyzerClasses.cardTitle}>
						Próximos passos sugeridos
					</Typography>
				</Grid>
				<Grid item>
					<Typography className={meetingAnalyzerClasses.cardSubtitle}>
						Ações concretas para aumentar a probabilidade de conversão.
					</Typography>
				</Grid>
				<Grid item>
					<Grid container direction="column" spacing={1}>
						{nextSteps.map((step, index) => (
							<Grid item key={index}>
								<Box className={classes.nextStepItem}>
									<Grid container alignItems="center" spacing={2}>
										<Grid item>
											<Box className={classes.nextStepIconContainer}>
												<Grid container alignItems="center" justifyContent="center">
													<AdjustIcon fontSize="small" />
												</Grid>
											</Box>
										</Grid>
										<Grid item xs>
											<Typography>
												{step}
											</Typography>
										</Grid>
									</Grid>
								</Box>
							</Grid>
						))}
					</Grid>
				</Grid>
			</Grid>
		</Card>
	)
}

export default NextStepsCard
